import {
  BRANCH_CODE_TO_NAME,
} from "LTCP Module/constants/mapping.js";

export const DEMAND_HIERARCHIES = {
  national: [
    {
      key: "subcategory",
      label: "Sub-Category",
    },
    {
      key: "brand",
      label: "Brand",
    },
    {
      key: "formatsL1",
      label: "Format L1",
    },
    {
      key: "formatsL2",
      label: "Format L2",
    },
    {
      key: "basepackcode",
      label: "Basepack",
      isLeaf: true,
    },
  ],

  branch: [
    {
      key: "branch",
      label: "Branch",
      formatValue: (value) =>
        BRANCH_CODE_TO_NAME[value] || value,
    },
    {
      key: "subcategory",
      label: "Sub-Category",
    },
    {
      key: "brand",
      label: "Brand",
    },
    {
      key: "formatsL1",
      label: "Format L1",
    },
    {
      key: "formatsL2",
      label: "Format L2",
    },
    {
      key: "basepackcode",
      label: "Basepack",
      isLeaf: true,
    },
  ],
};

export const HIERARCHY_HEADER_LABELS = {
  national: [
    "Sub-Category",
    "Brand",
    "Format L1",
    "Format L2",
    "Basepack",
  ],

  branch: [
    "Branch",
    "Sub-Category",
    "Brand",
    "Format L1",
    "Format L2",
    "Basepack",
  ],
};